module.exports = __webpack_public_path__ + "static/dicom-8d012e4d952af0c392cb16f5d63faa5a.jpg";